// extracted by mini-css-extract-plugin
module.exports = {"article":"activity-module--article--2bBOx"};